module.exports = __webpack_public_path__ + "static/img/cellular-respiration.88736aa4.jpg";